module.exports = __webpack_public_path__ + "static/liva-pastacilik-case-study-ramadan-8147d22a6f34a3e957ab29215d05ef14.png";